const INITIAL_STATE = {
  tasks: [],
  total: 0,
  isAdvancedSearch: false,
  listFilters: [{ query: 'operator_id', value: '' }, { query: 'order', value: 'last_created' }, { query: 'address_id', value: '' }, { query: 'rangeDate', value: '' }, { query: 'hiredDate', value: '' }, { query: 'chargedDate', value: '' }, { query: 'quotes', value: '' }, { query: 'charged', value: '' }, { query: 'hired', value: '' }, { query: 'service_id', value: '' }, { query: 'created', value: '' }, { query: 'filterTaskVisit', value: '' }, { query: 'label', value: [] }],
  activeFilters: [{ name: 'offset', value: 0 }],
  statusFilterActived: { id: 1, value: 'open' },
  taskDetail: {},
  taskQuoteProDetail: {},
  cancelTaskOptions: [],
  selectedTaskCanceled: false,
  quoteCanceled: false,
  reportProblem: {
    reasons: [],
    problems: [],
    success: false,
  },
  selectedTaskHired: false,
  loading: false,
  tabsStatus: [],
  optionsFilters: {},
  comments: [],
  commentsSize: 0,
  checkoutParams: {},
};

/**
 * Types
 */
export const Types = {
  GET_TASKS_REQUEST: 'tasks/GET_TASKS_REQUEST',
  GET_TASKS_SUCCESS: 'tasks/GET_TASKS_SUCCESS',
  GET_TASKS_FILTERS_REQUEST: 'tasks/GET_TASKS_FILTERS_REQUEST',
  GET_TASKS_FILTERS_SUCCESS: 'tasks/GET_TASKS_FILTERS_SUCCESS',
  GET_TASK_DETAIL_REQUEST: 'tasks/GET_TASK_DETAIL_REQUEST',
  GET_TASK_DETAIL_SUCCESS: 'tasks/GET_TASK_DETAIL_SUCCESS',
  GET_CANCEL_TASK_OPTIONS_REQUEST: 'tasks/GET_CANCEL_TASK_OPTIONS_REQUEST',
  GET_CANCEL_TASK_OPTIONS_SUCCESS: 'tasks/GET_CANCEL_TASK_OPTIONS_SUCCESS',
  SET_TASK_QUOTE_PRO_DETAIL: 'tasks/SET_TASK_QUOTE_PRO_DETAIL',
  HIRE_TASK_REQUEST: 'tasks/HIRE_TASK_REQUEST',
  HIRE_TASK_SUCCESS: 'tasks/HIRE_TASK_SUCCESS',
  CANCEL_QUOTE_TASK_REQUEST: 'tasks/CANCEL_QUOTE_TASK_REQUEST',
  CANCEL_QUOTE_TASK_SUCCESS: 'tasks/CANCEL_QUOTE_TASK_SUCCESS',
  CANCEL_HIRED_TASK_REQUEST: 'tasks/CANCEL_HIRED_TASK_REQUEST',
  CANCEL_HIRED_TASK_SUCCESS: 'tasks/CANCEL_HIRED_TASK_SUCCESS',
  RATING_TASK_PROFESSIONAL_REQUEST: 'tasks/RATING_TASK_PROFESSIONAL_REQUEST',
  RATING_TASK_PROFESSIONAL_SUCCESS: 'tasks/RATING_TASK_PROFESSIONAL_SUCCESS',
  AUTHORIZE_TASK_REQUEST: 'task/AUTHORIZE_TASK_REQUEST',
  AUTHORIZE_TASK_SUCCESS: 'task/AUTHORIZE_TASK_SUCCESS',
  SCHEDULING_TASK_REQUEST: 'task/SCHEDULING_TASK_REQUEST',
  SCHEDULING_TASK_SUCCESS: 'task/SCHEDULING_TASK_SUCCESS',
  ADD_PHOTOS_TO_TASK_REQUEST: 'tasks/ADD_PHOTOS_TO_TASK_REQUEST',
  REMOVE_PHOTO_FROM_TASK_REQUEST: 'tasks/REMOVE_PHOTO_FROM_TASK_REQUEST',
  SET_LAST_MESSAGE: 'tasks/SET_LAST_MESSAGE',
  SET_ACTIVE_FILTERS: 'tasks/SET_ACTIVE_FILTERS',
  REPORT_PROBLEM_REASONS_REQUEST: 'tasks/REPORT_PROBLEM_REASONS_REQUEST',
  REPORT_PROBLEM_REASONS_SUCCESS: 'tasks/REPORT_PROBLEM_REASONS_SUCCESS',
  REPORT_PROBLEM_REQUEST: 'tasks/REPORT_PROBLEM_REQUEST',
  REPORT_PROBLEM_SUCCESS: 'tasks/REPORT_PROBLEM_SUCCESS',
  GET_REPORT_PROBLEMS_REQUEST: 'tasks/GET_REPORT_PROBLEMS_REQUEST',
  GET_REPORT_PROBLEMS_SUCCESS: 'tasks/GET_REPORT_PROBLEMS_SUCCESS',
  TASK_PAYMENT_INFO_REQUEST: 'tasks/TASK_PAYMENT_INFO_REQUEST',
  TASK_PAYMENT_INFO_SUCCESS: 'tasks/TASK_PAYMENT_INFO_SUCCESS',
  SETUP_TASKS_FILTERS: 'tasks/SETUP_TASKS_FILTERS',
  EDIT_LOCAL_SUCCESS: 'locals/EDIT_LOCAL_SUCCESS',
  SET_LOADING: 'tasks/SET_LOADING',
  SET_STATUS_FILTER: 'tasks/SET_STATUS_FILTER',
  SET_LIST_FILTERS: 'tasks/SET_LIST_FILTERS',
  SET_STATUS_FILTER_SUCCESS: 'tasks/SET_STATUS_FILTER_SUCCESS',
  UPDATE_LAST_TASK_SUCCESS: 'tasks/UPDATE_LAST_TASK_SUCCESS',
  UPDATE_LAST_TASK_OF_LIST_SUCCESS: 'tasks/UPDATE_LAST_TASK_OF_LIST_SUCCESS',
  GET_TABS_STATUS_REQUEST: 'tasks/GET_TABS_STATUS_REQUEST',
  GET_TABS_STATUS_REQUEST_SUCCESS: 'tasks/GET_TABS_STATUS_REQUEST_SUCCESS',
  SET_TASK_IS_NEEDED_VISIT_REQUEST: 'tasks/SET_TASK_IS_NEEDED_VISIT_REQUEST',
  SET_TASK_IS_NEEDED_VISIT_SUCCESS: 'tasks/SET_TASK_IS_NEEDED_VISIT_SUCCESS',
  SET_DETAIL_TASK_IS_NEEDED_VISIT_SUCCESS: 'tasks/SET_DETAIL_TASK_IS_NEEDED_VISIT_SUCCESS',
  EDIT_TASK_VISIT_REQUEST: 'tasks/EDIT_TASK_VISIT_REQUEST',
  EDIT_TASK_VISIT_SUCCESS: 'tasks/EDIT_TASK_VISIT_SUCCESS',
  EDIT_DETAIL_TASK_VISIT_SUCCESS: 'tasks/EDIT_DETAIL_TASK_VISIT_SUCCESS',
  GET_COMMENTS_REQUEST: 'tasks/GET_COMMENTS_REQUEST',
  GET_COMMENTS_SUCCESS: 'tasks/GET_COMMENTS_SUCCESS',
  INCLUDE_COMMENTS_REQUEST: 'tasks/INCLUDE_COMMENTS_REQUEST',
  INCLUDE_COMMENTS_SUCCESS: 'tasks/INCLUDE_COMMENTS_SUCCESS',
  SET_TASK_OPERATOR_REQUEST: 'tasks/SET_TASK_OPERATOR_REQUEST',
  SET_TASK_OPERATOR_SUCCESS: 'tasks/SET_TASK_OPERATOR_SUCCESS',
  SET_TASK_OPERATOR_SUCCESS_DETAIL: 'tasks/SET_TASK_OPERATOR_SUCCESS_DETAIL',
  SET_CHECKOUT_PARAMS: 'tasks/SET_CHECKOUT_PARAMS',
  SET_TASK_USER_SUCCESS: 'tasks/SET_TASK_USER_SUCCESS',
  INCLUDE_LABELS_TASK_REQUEST: 'taks/INCLUDE_LABELS_TASK_REQUEST',
  INCLUDE_LABELS_TASK_SUCCESS: 'taks/INCLUDE_LABELS_TASK_SUCCESS',
  REMOVE_LABELS_TASK_REQUEST: 'taks/REMOVE_LABELS_TASK_REQUEST',
  REMOVE_LABELS_TASK_SUCCESS: 'taks/REMOVE_LABELS_TASK_SUCCESS',
};

/**
 * Reducer
 */
export default function tasks(state = INITIAL_STATE, action) {
  switch (action.type) {
    case Types.GET_TASKS_SUCCESS: {
      const { tasks: data, total, filters } = action.payload;
      return {
        ...state,
        tasks: data,
        total,
        optionsFilters: filters,
      };
    }
    case Types.GET_TASKS_FILTERS_SUCCESS: {
      const {
        payload: { key, options },
      } = action;
      return {
        ...state,
        filtersOptions: {
          ...state.filtersOptions,
          [key]: options,
        },
      };
    }
    case Types.SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    case Types.SET_TASK_QUOTE_PRO_DETAIL:
      return { ...state, taskQuoteProDetail: action.payload };
    case Types.GET_TASK_DETAIL_SUCCESS: {
      const selectedPro = action.payload.quotes && action.payload.quotes.length ? action.payload.quotes[0] : {};
      return { ...state, taskDetail: action.payload, taskQuoteProDetail: selectedPro };
    }
    case Types.SET_PRO_DETAIL:
      return { ...state, taskQuoteProDetail: action.payload };
    case Types.GET_CANCEL_TASK_OPTIONS_SUCCESS:
      return { ...state, cancelTaskOptions: action.payload };
    case Types.CANCEL_QUOTE_TASK_SUCCESS:
      return { ...state, quoteCanceled: action.payload };
    case Types.CANCEL_HIRED_TASK_SUCCESS:
      return { ...state, selectedTaskCanceled: action.payload };
    case Types.RATING_TASK_PROFESSIONAL_SUCCESS:
      return { ...state, taskDetail: { ...state.taskDetail, status: 'done' } };
    // Trocar aqui para trazer de volta o resultado do fromTenant
    case Types.AUTHORIZE_TASK_SUCCESS:
      return {
        ...state,
        taskQuoteProDetail: { ...state.taskQuoteProDetail, approved: action.payload.success },
      };
    case Types.SCHEDULING_TASK_SUCCESS:
      return { ...state, scheduling: action.payload };
    case Types.HIRE_TASK_SUCCESS:
      return { ...state, selectedTaskHired: action.payload };
    case Types.SET_LAST_MESSAGE: {
      const {
        chat_id, message: last_message, is_read: last_message_read, time,
      } = action.payload;
      const { taskDetail } = state;
      const { quotes: lastQuotes } = taskDetail;
      const quotes = lastQuotes.map(q => (q.chat_id === chat_id
        ? {
          ...q,
          last_message,
          last_message_read,
          last_message_date: time || Date.now(),
        }
        : q));
      return { ...state, taskDetail: { ...taskDetail, quotes } };
    }
    case Types.SET_ACTIVE_FILTERS:
      return { ...state, activeFilters: action.payload };
    case Types.SET_STATUS_FILTER_SUCCESS:
      return {
        ...state,
        statusFilterActived: action.payload,
        activeFilters: [{ name: 'offset', value: action.payload.offset }],
      };

    case Types.REPORT_PROBLEM_REASONS_SUCCESS:
      return { ...state, reportProblem: { ...state.reportProblem, reasons: action.payload } };

    case Types.REPORT_PROBLEM_SUCCESS:
      return { ...state, reportProblem: { ...state.reportProblem, ...action.payload } };

    case Types.GET_REPORT_PROBLEMS_SUCCESS:
      return { ...state, reportProblem: { ...state.reportProblem, problems: action.payload } };

    case Types.TASK_PAYMENT_INFO_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          billing_info: action.payload.billing_info,
          taskAddress: {
            ...state.taskDetail.taskAddress,
            address_owner: action.payload.address_owner || {},
          },
        },
      };

    case Types.EDIT_LOCAL_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          taskAddress: {
            ...state.taskDetail.taskAddress,
            ...action.payload.address,
          },
        },
      };

    case Types.SET_LIST_FILTERS:
      return {
        ...state,
        listFilters: action.payload.listFilters,
        isAdvancedSearch: action.payload.isAdvancedSearch,
      };

    case Types.UPDATE_LAST_TASK_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          responsibility_bucket_id: action.payload.responsibility_bucket_id,
        },
      };
    case Types.UPDATE_LAST_TASK_OF_LIST_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => (task.id === action.payload.id
          ? { ...task, responsibility_bucket_id: action.payload.responsibility_bucket_id }
          : task)),
      };
    case Types.GET_TABS_STATUS_REQUEST_SUCCESS:
      return {
        ...state,
        tabsStatus: action.payload,
      };

    case Types.SET_TASK_IS_NEEDED_VISIT_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => (task.id === action.payload.task_id
          ? { ...task, is_needed_visit: action.payload.isNeedVisit }
          : task)),
      };
    case Types.SET_DETAIL_TASK_IS_NEEDED_VISIT_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          is_needed_visit: action.payload.isNeedVisit,
        },
      };
    case Types.EDIT_TASK_VISIT_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => (task.id === action.payload.task_id
          ? {
            ...task, visit_id: action.payload.id, visit_status: action.payload.status, visit_scheduling_date: action.payload.scheduling_date, visit_is_active: action.payload.is_active,
          }
          : task)),
      };
    case Types.EDIT_DETAIL_TASK_VISIT_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          visit_id: action.payload.id,
          visit_status: action.payload.status,
          visit_scheduling_date: action.payload.scheduling_date,
          visit_is_active: action.payload.is_active,
        },
      };

    case Types.GET_COMMENTS_SUCCESS:
      return {
        ...state, comments: action.payload.comments, commentsSize: action.payload.commentsSize,
      };
    case Types.INCLUDE_COMMENTS_SUCCESS:
      return {
        ...state, comments: [action.payload, ...state.comments],
      };

    case Types.SET_TASK_OPERATOR_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => (task.id === action.payload.task_id
          ? {
            ...task, operator_id: action.payload.operator_id,
          }
          : task)),
      };
    case Types.SET_TASK_OPERATOR_SUCCESS_DETAIL:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          operator_id: action.payload.operator_id,
        },
      };
    case Types.SET_CHECKOUT_PARAMS: {
      return { ...state, checkoutParams: action.payload };
    }
    case Types.SET_TASK_USER_SUCCESS:
      return {
        ...state,
        tasks: state.tasks.map(task => (task.id === action.payload.task_id
          ? {
            ...task,
            user_id: action.payload.user_id,
            user_name: action.payload.name,
            profile_picture: action.payload.profile_picture,
            source: action.payload.source,
          }
          : task)),
      };
    case Types.INCLUDE_LABELS_TASK_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          labels: [
            ...state.taskDetail.labels,
            action.payload,
          ],
        },
      };
    case Types.REMOVE_LABELS_TASK_SUCCESS:
      return {
        ...state,
        taskDetail: {
          ...state.taskDetail,
          labels: state.taskDetail.labels.filter(label => label.id !== action.payload.label_id),
        },
      };
    default:
      return state;
  }
}

/**
 * Actions Creators
 */
export const Creators = {
  getTasksRequest: payload => ({
    type: Types.GET_TASKS_REQUEST,
    payload,
  }),
  getTasksSuccess: payload => ({
    type: Types.GET_TASKS_SUCCESS,
    payload,
  }),
  setUpTaskFilters: payload => ({
    type: Types.SETUP_TASKS_FILTERS,
    payload,
  }),
  getTasksFiltersRequest: payload => ({
    type: Types.GET_TASKS_FILTERS_REQUEST,
    payload,
  }),
  getTasksFiltersSuccess: payload => ({
    type: Types.GET_TASKS_FILTERS_SUCCESS,
    payload,
  }),
  getTaskDetailRequest: payload => ({
    type: Types.GET_TASK_DETAIL_REQUEST,
    payload,
  }),
  getTaskDetailSuccess: payload => ({
    type: Types.GET_TASK_DETAIL_SUCCESS,
    payload,
  }),
  setTaskQuoteProDetail: payload => ({
    type: Types.SET_TASK_QUOTE_PRO_DETAIL,
    payload,
  }),
  hireTaskRequest: payload => ({
    type: Types.HIRE_TASK_REQUEST,
    payload,
  }),
  hireTaskSuccess: payload => ({
    type: Types.HIRE_TASK_SUCCESS,
    payload,
  }),
  getCancelTaskOptionsRequest: payload => ({
    type: Types.GET_CANCEL_TASK_OPTIONS_REQUEST,
    payload,
  }),
  getCancelTaskOptionsSuccess: payload => ({
    type: Types.GET_CANCEL_TASK_OPTIONS_SUCCESS,
    payload,
  }),
  getTabsStatusRequest: () => ({
    type: Types.GET_TABS_STATUS_REQUEST,
  }),
  getTabsStatusSuccess: payload => ({
    type: Types.GET_TABS_STATUS_REQUEST_SUCCESS,
    payload,
  }),

  setQuoteCanceledRequest: payload => ({
    type: Types.CANCEL_QUOTE_TASK_REQUEST,
    payload,
  }),
  setQuoteCanceledSuccess: payload => ({
    type: Types.CANCEL_QUOTE_TASK_SUCCESS,
    payload,
  }),
  cancelHiredTaskRequest: payload => ({
    type: Types.CANCEL_HIRED_TASK_REQUEST,
    payload,
  }),
  cancelHiredTaskSuccess: payload => ({
    type: Types.CANCEL_HIRED_TASK_SUCCESS,
    payload,
  }),
  ratingTaskProfessionalRequest: payload => ({
    type: Types.RATING_TASK_PROFESSIONAL_REQUEST,
    payload,
  }),
  ratingTaskProfessionalSuccess: payload => ({
    type: Types.RATING_TASK_PROFESSIONAL_SUCCESS,
    payload,
  }),
  authorizeTaskRequest: payload => ({
    type: Types.AUTHORIZE_TASK_REQUEST,
    payload,
  }),
  authorizeTaskSuccess: payload => ({
    type: Types.AUTHORIZE_TASK_SUCCESS,
    payload,
  }),
  schedulingRequest: payload => ({
    type: Types.SCHEDULING_TASK_REQUEST,
    payload,
  }),
  schedulingSuccess: payload => ({
    type: Types.SCHEDULING_TASK_SUCCESS,
    payload,
  }),
  addPhotosToTaskRequest: payload => ({
    type: Types.ADD_PHOTOS_TO_TASK_REQUEST,
    payload,
  }),
  removePhotosFromTaskRequest: payload => ({
    type: Types.REMOVE_PHOTO_FROM_TASK_REQUEST,
    payload,
  }),
  setLastMessage: payload => ({
    type: Types.SET_LAST_MESSAGE,
    payload,
  }),
  setActiveFilters: payload => ({
    type: Types.SET_ACTIVE_FILTERS,
    payload,
  }),
  reportProblemReasonsRequest: payload => ({
    type: Types.REPORT_PROBLEM_REASONS_REQUEST,
    payload,
  }),
  reportProblemReasonsSuccess: payload => ({
    type: Types.REPORT_PROBLEM_REASONS_SUCCESS,
    payload,
  }),
  reportProblemRequest: payload => ({
    type: Types.REPORT_PROBLEM_REQUEST,
    payload,
  }),
  reportProblemSuccess: payload => ({
    type: Types.REPORT_PROBLEM_SUCCESS,
    payload,
  }),
  getReportProblemsRequest: payload => ({
    type: Types.GET_REPORT_PROBLEMS_REQUEST,
    payload,
  }),
  getReportProblemsSuccess: payload => ({
    type: Types.GET_REPORT_PROBLEMS_SUCCESS,
    payload,
  }),
  taskPaymentInfoRequest: payload => ({
    type: Types.TASK_PAYMENT_INFO_REQUEST,
    payload,
  }),
  setLoading: isLoading => ({
    type: Types.SET_LOADING,
    payload: isLoading,
  }),
  taskPaymentInfoSuccess: payload => ({
    type: Types.TASK_PAYMENT_INFO_SUCCESS,
    payload,
  }),
  editLocalSuccess: payload => ({
    type: Types.EDIT_LOCAL_SUCCESS,
    payload,
  }),
  getTasksFilter: payload => ({
    type: Types.SET_STATUS_FILTER,
    payload,
  }),
  setStatusSuccess: payload => ({
    type: Types.SET_STATUS_FILTER_SUCCESS,
    payload,
  }),
  setListFilters: payload => ({
    type: Types.SET_LIST_FILTERS,
    payload,
  }),
  updateLastTaskSuccess: payload => ({
    type: Types.UPDATE_LAST_TASK_SUCCESS,
    payload,
  }),
  updateLastTaskOfListSuccess: payload => ({
    type: Types.UPDATE_LAST_TASK_OF_LIST_SUCCESS,
    payload,
  }),
  setTaskIsNeededVisitRequest: payload => ({
    type: Types.SET_TASK_IS_NEEDED_VISIT_REQUEST,
    payload,
  }),
  setTaskIsNeededVisitSuccess: payload => ({
    type: Types.SET_TASK_IS_NEEDED_VISIT_SUCCESS,
    payload,
  }),
  setDetailTaskIsNeededVisitSuccess: payload => ({
    type: Types.SET_DETAIL_TASK_IS_NEEDED_VISIT_SUCCESS,
    payload,
  }),
  editTaskVisitRequest: payload => ({
    type: Types.EDIT_TASK_VISIT_REQUEST,
    payload,
  }),
  editTaskVisitSucess: payload => ({
    type: Types.EDIT_TASK_VISIT_SUCCESS,
    payload,
  }),
  editDetailTaskVisitSucess: payload => ({
    type: Types.EDIT_DETAIL_TASK_VISIT_SUCCESS,
    payload,
  }),
  getCommentsRequest: payload => ({
    type: Types.GET_COMMENTS_REQUEST,
    payload,
  }),
  getCommentsSuccess: payload => ({
    type: Types.GET_COMMENTS_SUCCESS,
    payload,
  }),
  includeCommentRequest: payload => ({
    type: Types.INCLUDE_COMMENTS_REQUEST,
    payload,
  }),
  includeCommentSuccess: payload => ({
    type: Types.INCLUDE_COMMENTS_SUCCESS,
    payload,
  }),
  setTaskOperatorRequest: payload => ({
    type: Types.SET_TASK_OPERATOR_REQUEST,
    payload,
  }),
  setTaskOperatorSuccess: payload => ({
    type: Types.SET_TASK_OPERATOR_SUCCESS,
    payload,
  }),
  setTaskOperatorSuccessDetail: payload => ({
    type: Types.SET_TASK_OPERATOR_SUCCESS_DETAIL,
    payload,
  }),
  setCheckoutParams: payload => ({
    type: Types.SET_CHECKOUT_PARAMS,
    payload,
  }),
  setTaskUserSuccess: payload => ({
    type: Types.SET_TASK_USER_SUCCESS,
    payload,
  }),
  includeLabelsTaskRequest: payload => ({
    type: Types.INCLUDE_LABELS_TASK_REQUEST,
    payload,
  }),
  includeLabelsTaskSuccess: payload => ({
    type: Types.INCLUDE_LABELS_TASK_SUCCESS,
    payload,
  }),
  removeLabelsTaskRequest: payload => ({
    type: Types.REMOVE_LABELS_TASK_REQUEST,
    payload,
  }),
  removeLabelsTaskSuccess: payload => ({
    type: Types.REMOVE_LABELS_TASK_SUCCESS,
    payload,
  }),
};
